import React, { useMemo } from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LaunchIcon from "@mui/icons-material/Launch";

const ctaSx = {
  borderRadius: "999px",
  textTransform: "capitalize" as const,
  px: 3,
  py: 1.25,
  background: "linear-gradient(135deg, #123524 0%, #1f7a4d 100%)",
  boxShadow: "0 8px 24px rgba(18, 53, 36, 0.2)",
  "&:hover": {
    background: "linear-gradient(135deg, #0f2d1f 0%, #1a6b42 100%)",
  },
};

const MediaLinkedIn: React.FC = () => {
  const linkedinPosts = useMemo(
    () => [
      "https://www.linkedin.com/embed/feed/update/urn:li:share:7297940425963642880",
      "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7289633322438139904",
      "https://www.linkedin.com/embed/feed/update/urn:li:share:7296155325341093888",
    ],
    []
  );

  return (
    <Box sx={{ marginTop: { xs: 0, sm: "1rem" } }}>
      <Container maxWidth="lg" sx={{ textAlign: "center", px: { xs: 2, sm: 3 } }}>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{
            fontWeight: 700,
            margin: "2rem auto",
            color: "#123524",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          Featured
          <Box
            component="span"
            sx={{
              color: "#0A66C2",
              display: "inline-flex",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            LinkedIn
            <LinkedInIcon sx={{ fontSize: { xs: "1.75rem", sm: "2rem" } }} />
          </Box>
          posts
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
            flexWrap: "wrap",
            margin: "auto",
          }}
        >
          {linkedinPosts.map((post, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              style={{
                maxWidth: "340px",
                overflow: "hidden",
                borderRadius: "12px",
                width: "-webkit-fill-available",
                border: "1px solid rgba(18, 53, 36, 0.1)",
                boxShadow: "0 8px 24px rgba(18, 53, 36, 0.08)",
              }}
            >
              <iframe
                src={post}
                width="100%"
                height="600"
                style={{
                  border: "none",
                  borderRadius: "10px",
                  overflow: "hidden",
                  maxWidth: "340px",
                  width: "-webkit-fill-available",
                }}
                allowFullScreen
              ></iframe>
            </motion.div>
          ))}
        </Box>
        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.9 }}
          style={{ marginTop: "20px" }}
        >
          <Button
            variant="contained"
            size="large"
            href="https://www.linkedin.com/company/salontymindia/"
            target="_blank"
            rel="noopener noreferrer"
            endIcon={<LaunchIcon />}
            sx={ctaSx}
          >
            Check out more
          </Button>
        </motion.div>
        <br />
      </Container>
    </Box>
  );
};

export default MediaLinkedIn;
